import template from './templates/time-range.tmpl.html';

export default function TimeRange() {
            return {
                template,
                restrict: 'A',
                require: 'ngModel',
                scope: {
                    minimum: '=',
                    maximum: '=',
                    rangeValues: '=ngModel',
                    halfHourStep: '=',
                },
                link: function(scope, element) {
                    function convertTime(val, format = 'HH[h]:mm[min]') {
                        let result;
                        const value = parseInt(val, 10);
                        const days = moment.duration(value).days();
                        const time = moment(value).utc();
                        const hoursMinutes = scope.halfHourStep
                                ? time.minutes(Math.round(time.minute() / 30) * 30).format(format)
                                : time.format(format);

                        if (days > 0 && format !== 'HH:mm') {
                            result = days + 'd ' + hoursMinutes;
                        } else {
                            result = hoursMinutes;
                        }

                        return result;
                    }

                    //init converted scope
                    scope.rangeValues.convertedModel = scope.rangeValues.model;

                    scope.$watch('rangeValues', function(val) {
                        scope.rangeValues.convertedModel = convertTime(val.model);
                        scope.rangeValues.convertedRange = convertTime(val.range);
                    });

                    scope.rangeValues.convertedRange = scope.rangeValues.model;

                    scope.$watch('rangeValues.model', function(val) {
                        scope.rangeValues.convertedModel = convertTime(val);
                    });
                    scope.$watch('rangeValues.range', function(val) {
                        scope.rangeValues.convertedRange = convertTime(val);
                    });

                    element.on('mousedown', function() {
                        // TODO: add code to catch input:text, and add prevent:default
                    });

                    /**
                     * Listen for change events and write data to the model
                     */
                    element.on('mouseup keyup touchend', function() {
                        scope.$apply(function() {
                            scope.minimum
                                = moment.duration(scope.rangeValues.model).days() + '.'
                                + convertTime(scope.rangeValues.model, 'HH:mm');
                            scope.maximum
                                = moment.duration(scope.rangeValues.range).days() + '.'
                                + convertTime(scope.rangeValues.range, 'HH:mm');
                        });
                    });
                },
            };
}



// WEBPACK FOOTER //
// ./src/app/directives/timeRange.directive.js